import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDivWrapper = styled.div`
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}
`;

export const StyledDiv = styled.div<{ mode: 'dark' | 'light' }>`
	max-width: 1420px;
	margin: 0 auto;
	position: relative;
	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;

	background-color: ${(props) =>
		props.mode === 'light' ? CSSVars.gray50 : CSSVars.black};
	border-radius: 10px;
	color: ${(props) => (props.mode === 'light' ? CSSVars.black : CSSVars.white)};
	display: flex;
	align-items: center;
	gap: 10px;

	padding: 0 30px;
	flex-direction: column;

	img {
		max-width: 100%;
		height: 100%;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		gap: 30px;
		flex-direction: row-reverse;
		align-items: flex-end;
		justify-content: center;
	}

	@media screen and (min-width: ${CSSVars.breakpointXL}) {
		padding: 0 120px;
	}

	&.developers-banner {
		background-color: #fff;
		background: linear-gradient(90deg, #3a51af 0%, #798fe9 100%);
	}

	&.more-padding {
		padding: 30px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 40px 60px;
		}

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			padding: 100px 120px;
		}
	}

	.text-wrapper {
		max-width: 515px;
		padding: 50px 0;
		
		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			padding: 100px 0;
		}

		h3 {
			max-width: 700px;
			z-index: 10;
			font-weight: 500;
			position: relative;
			font-size: ${CSSVars.fontSizeXL};
		}

		p {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeMD};
			z-index: 10;
			position: relative;
			margin: 10px 0 20px;
		}

		a {
			color: ${CSSVars.white};
			display: flex;
			align-items: center;
			gap: 10px;
			font-weight: 500;
			font-size: ${CSSVars.fontSizeMD};
			width: fit-content;

			.icon {
				padding-top: 2px;
			}

			&:hover {
				opacity: 0.8;
				text-decoration: underline;
			}
		}
	}
`;
